/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { LicenseAgreementRestService, UserLicenseAgreementDto } from '@gh/builder-shared-data';
import { InitDialogViewService } from '@gh/common-shared';
import { map$, switchMap$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';

export interface LicenseAgreementDialogConfig {
  viewMode: boolean;
}

export type UserAgreement = UserLicenseAgreementDto;

@Injectable()
export class LicenseAgreementDialogBusinessService implements InitDialogViewService<LicenseAgreementDialogConfig> {
  constructor(private licenseAgreementRest: LicenseAgreementRestService) {
  }

  initDialogView(): any {
    return this.licenseAgreementRest.getUserAgreement().pipe(
      switchMap$((agreement) =>
        this.licenseAgreementRest
          .downloadLicenseAgreement(agreement.agreementId).pipe(
          map$((eulaDocument) => ({ eulaDocument, agreement })))));
  }

  accept(agreement: UserAgreement): Observable<void> {
    return this.licenseAgreementRest.acceptUserAgreement(agreement);
  }
}
